import { action } from "easy-peasy";
import { WhatsNewModelInterface } from "./WhatsNewModelInterface";
import image from "../../../assets/img/autosave-whats-new.png";
import { i18n } from "../../../i18n";

const whatsNewModel: WhatsNewModelInterface = {
  visible: true, // Start visible to show on first load
  items: [
    {
      imageUrl: image,
      description: i18n.t("whatsNew.autosave")
    }
  ],
  
  setVisible: action((state, payload) => {
    state.visible = payload;
  }),
  
  addItem: action((state, payload) => {
    state.items.push(payload);
  }),
  
  clearItems: action(state => {
    state.items = [];
  })
};

export default whatsNewModel; 